<template>
    <div class="bookmark-component">
        <Tabs :animated="false" @on-click="onTabClick" v-model="tabName">
            <TabPane label="Joined" name="1">
                <EventsByStatus type="accepted"></EventsByStatus>
            </TabPane>
            <TabPane label="Invited" name="2">                
                <EventsByStatus type="pending"></EventsByStatus>
            </TabPane>            
            <TabPane label="Interested" name="3">                
                <EventsByStatus type="interested"></EventsByStatus>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
import EventsByStatus from "@/components/EventsByStatus"
export default {
    components:{
        EventsByStatus
    },
    data(){
        return{
            tabName:''
        }
    },
    methods:{
        onTabClick(){

        }
    }
}
</script>

<style>

</style>
